<!-- src/app/app.component.html -->

<!-- NETWORK STATUS BANNER (Offline/Online Indicator) -->
<app-network-status-banner></app-network-status-banner>

<!-- HELP-HUB: vereint Q&A-Chat + Einrichtungs-Checkliste in EINEM Launcher (unten rechts). Siehe unten. -->


<!-- TRIAL EXPIRY BANNER (shown for admins when trial is ending/expired).
     Wie der Demo-Banner: auf Mobile-Admin NICHT hier (vor der fixen Nav), sondern im
     Scroll-Fluss von `main` (siehe unten) — sonst läge er hinter der fixen Nav und
     erzeugte einen toten Offset über dem Seiteninhalt. -->
<app-trial-banner *ngIf="isLoggedin && !isMobileAdminView"></app-trial-banner>

<!-- DEMO-MODUS BANNER (nur bei aktiver Demo-Session; Restlauf + "Jetzt registrieren"-CTA).
     Im Mobile-Admin-Layout wird der Banner NICHT hier (vor der fixen Top-Nav) gerendert —
     dort läge er hinter der fixen Nav und schöbe den Inhalt um seine Höhe nach unten. Statt-
     dessen sitzt er auf Mobile im Scroll-Fluss von `main` (siehe unten), damit er sichtbar
     unter der Nav beginnt UND beim Runterscrollen wegscrollt. -->
<app-demo-banner *ngIf="isLoggedin && !isMobileAdminView"></app-demo-banner>

<!-- ONBOARDING NUDGE (Welcome-Tour-Offer nach Login, dezenter Banner oben rechts).
     NICHT auf der Registered-Stepper-Route — dort soll der Fokus auf dem
     Intro-Video bleiben, ohne konkurrierende Tour-Vorschläge daneben. -->
<app-onboarding-nudge
  *ngIf="isLoggedin && !isRegisteredStepperRoute()"
></app-onboarding-nudge>

<!-- DEMO-QUICK-TOUR-WIEDEREINSTIEG (Reiter am rechten Rand, seitenuebergreifend).
     Nur intern sichtbar (Komponente prueft selbst isDemoSessionActive()) — die
     Demo-Kette spannt drei Routen (/planner, /time-recording, /absence), ein
     Wiedereinstieg nur auf einer Seite waere auf den anderen unsichtbar. -->
<app-demo-tour-resume-tab *ngIf="isLoggedin"></app-demo-tour-resume-tab>

<!-- ANIMATED SPLASHSCREEN -->
<app-splashscreen></app-splashscreen>

<app-spinner *ngIf="globalSpinnerVisible$ | async" [size]="'full'" [overlay]="true" [showLogo]="true" [showAppName]="false"></app-spinner>

<!-- NEUER MOBILER ADMIN HEADER -->
<app-admin-mobile-header
  *ngIf="isMobileAdminView"
  (menuToggle)="toggleAdminMobileSidebar()"
></app-admin-mobile-header>

<!-- DESKTOP HEADER (Nur bei Topbar-Layout, NICHT im Mobile Admin View) -->
<app-page-header *ngIf="shouldShowDesktopHeader()"></app-page-header>

<!-- TERMINAL HEADER (Desktop - Logik sollte schon passen) -->
<app-page-header-terminal
  *ngIf="
    !isMobile &&
    isLoggedin &&
    authService.isTerminal &&
    !isRegisteredStepperRoute()
  "
></app-page-header-terminal>

<!-- `with-mobile-admin-header` stand hier bis 2026-09-04 als Bindung, hatte aber in
     keinem der 355 Stylesheets eine Regel — ein toter Haken, der bei jeder Suche nach
     dem Mobile-Admin-Rahmen als Fundstelle mitkam. -->
<div
  class="app-body-wrapper"
  [class.no-top-padding]="shouldHaveNoTopPadding()"
>
  <!-- ADMIN SIDEBAR (wird jetzt für Desktop UND Mobile Admin View verwendet, aber unterschiedlich gesteuert) -->
  <app-admin-sidebar
    *ngIf="shouldShowAdminSidebarComponent()"
    [isMobileMode]="isMobileAdminView"
    [isOpenOnMobile]="isMobileAdminSidebarOpen"
    (mobileClose)="toggleAdminMobileSidebar()"
    [isCompact]="
      !isMobileAdminView &&
      activeLayout === LayoutMode.COMPACT_SIDEBAR
    "
  ></app-admin-sidebar>

  <main
    class="main-content-area"
    [ngClass]="getMainContentClasses()"
    [style.paddingTop]="getMainContentPaddingTop()"
    id="main-content-scroll-area"
    appPullToRefresh
    [pullEnabled]="isPullToRefreshEnabled"
    (refresh)="handleMobileAdminRefresh()"
  >
    <!-- TRIAL-/DEMO-BANNER (Mobile-Admin): im Scroll-Fluss ganz oben in `main` — beginnen
         sichtbar unter der fixen Nav und scrollen beim Runterscrollen weg (machen Platz
         für die Liste). Desktop rendert dieselben Banner weiterhin oben vor der App-Shell. -->
    <app-trial-banner *ngIf="isLoggedin && isMobileAdminView"></app-trial-banner>
    <app-demo-banner *ngIf="isLoggedin && isMobileAdminView"></app-demo-banner>

    <!-- DESKTOP TOP ACTIONS BAR (Sidebar/Compact-Layout, normale Mitarbeiter-Desktop) —
         im Dokumentfluss statt frei schwebend: reserviert echten Platz, überlappt
         daher keine Seiten-Aktionen mehr. Terminal hat mit app-page-header-terminal
         bereits einen eigenen Header, Topbar-Layout bindet die Controls direkt in
         app-page-header ein — beide daher hier ausgeschlossen. -->
    <app-top-actions-bar
      *ngIf="shouldShowInlineTopActionsBar()"
      class="inline-top-actions-bar"
    ></app-top-actions-bar>

    <!--
      EINE router-outlet ist immer da.
      Der optionale Container darum wird bedingt angezeigt.
    -->
    <div
      *ngIf="shouldUseContainerFluid()"
      class="container-fluid content-container"
    >
      <!-- Dieser Container wird verwendet, wenn es NICHT die Employee Mobile Tabs SIND
           UND es AUCH NICHT eine öffentliche oder Stepper-Route IST.
           D.h. für eingeloggte Desktop-User oder Admin-Mobile-User,
           die eine Seite mit dem Standard-Container benötigen. -->
      <router-outlet></router-outlet>
    </div>

    <router-outlet *ngIf="!shouldUseContainerFluid()"></router-outlet>
    <!-- Diese router-outlet wird verwendet, wenn es die Employee Mobile Tabs SIND
         ODER es eine öffentliche oder Stepper-Route IST.
         Hier wollen wir oft keinen globalen Wrapper-Container. -->
  </main>
</div>
<!-- HELP-HUB: ein Launcher unten rechts (Tabs: Fragen / Einrichtung).
     Ersetzt den frueheren Help-FAB (unten rechts) UND die Einrichtungs-Pille (unten links). -->
<app-help-hub
  *ngIf="isLoggedin && !isRegisteredStepperRoute() && (hasHelpHub$ | async)"
></app-help-hub>
